import React from "react";
import Script from "next/script";

function GtmScript() {
  return (
    <Script
      id="gtm-script"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
          var gtmQueryString = (window.location.href.indexOf('www') !== -1)
            ? '&gtm_auth=o8gxBYDICnW1O3EVg59lKg&gtm_preview=env-1&gtm_cookies_win=x'
            : '&gtm_auth=VMOfWSnNEyownaEoH-SKiw&gtm_preview=env-6&gtm_cookies_win=x';
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl+gtmQueryString;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-M6SVJ7');
        `,
      }}
    />
  );
}

export default React.memo(GtmScript);
